export default "__VITE_ASSET__561191a3__"